import { Station } from '@mi-front/core';
import { useMemo } from 'react';
import { useStationsStore } from '../stores';
import { useStations } from './useStations';

/**
 * Returns the default station to navigate to: the most recently used station
 * if it exists in the stations list; otherwise the first favorite station;
 * otherwise the first station. Returns null when there are no stations.
 */
export function useDefaultStation(): Station {
  const stations = useStations();
  const recentStationIds = useStationsStore((state) => state.recentStationIds);
  const favoriteStationIds = useStationsStore((state) => state.favoriteStationIds);

  return useMemo(() => {
    const mostRecentId = recentStationIds[0];
    const recentStation = mostRecentId && stations.find((s) => s.id === mostRecentId);

    if (recentStation) {
      return recentStation;
    }

    // First in user's favorites list that still exists in the stations list
    const firstFavoriteId = favoriteStationIds.find((id) => stations.some((s) => s.id === id));

    return stations.find((s) => s.id === firstFavoriteId) ?? stations[0];
  }, [stations, recentStationIds, favoriteStationIds]);
}
